export function trackPageView() {
    window._paq.push(["trackPageView"]);
}

export function trackEvent(name, value) {
    window._paq.push(['trackEvent', name, value]);
}
